import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Tab } from '../models/utils-tabs';
import { TableType } from '../../../models/shipment';
import { Observable, Subject } from 'rxjs';

interface TabRequest {
  order: number;
  name: string;
  type: TableType;
  filters: TabFilter[];
  columns: TabColumn[];
  sorts: TabSort[];
}

interface TabFilter {
  order: number;
  columnKey: string;
  filterKey: string;
  parameters: { value: any } | { from: any; to: any };
}

interface TabColumn {
  columnKey: string;
  order: number;
}

interface TabSort {
  order: number;
  columnKey: string;
  direction: 'Asc' | 'Desc';
}

interface TabReorder {
  tabId: number;
  order: number;
}

export type RefreshTab = 'selectLastTab' | number | null;

@Injectable({
  providedIn: 'root'
})
export class UtilsTabsService {
  private refreshTabs$ = new Subject<RefreshTab>();

  constructor(private http: HttpClient) {}

  getTabs(options: { type: TableType | null; archive: boolean }): Observable<Tab[]> {
    let params = new HttpParams();
    if (options.type) {
      params = params.append('type', options.type);
    }
    if (options.archive) {
      params = params.append('archive', options.archive);
    }
    return this.http.get<Tab[]>(`${environment.apiUrl}/tabs`, { params });
  }

  createTab(data: TabRequest) {
    return this.http.post(`${environment.apiUrl}/tabs`, this.mappedFormData(data));
  }

  updateTab(id: number, data: TabRequest) {
    return this.http.put(`${environment.apiUrl}/tabs/${id}`, this.mappedFormData(data));
  }

  reorderTabs(tabs: TabReorder[]) {
    return this.http.post(`${environment.apiUrl}/tabs/reorder`, tabs);
  }

  deleteTab(id: number) {
    return this.http.delete(`${environment.apiUrl}/tabs/${id}`);
  }

  setTabsRefresh(val?: RefreshTab) {
    this.refreshTabs$.next(val ?? null);
  }

  getTabsRefresh() {
    return this.refreshTabs$.asObservable();
  }

  private mappedFormData(data: TabRequest) {
    return {
      ...data,
      filters: data.filters.map(filter => {
        if ('value' in filter.parameters) {
          let value = filter.parameters.value;
          if (typeof value === 'number') {
            value = value.toString();
          }
          return { ...filter, parameters: { value } };
        }
        return filter;
      })
    };
  }
}
